import React, { useState, useContext } from 'react';
import { TranslationContext, SettingsContext } from "./Context";
import { GetData } from './Fetch';
import ProductListItem from './Product/ProductListItem';
import useFetch from './useFetch';
import SearchArticle from './SearchArticle';

function SearchTab(props) {

    const translation = useContext(TranslationContext);
    const settings = useContext(SettingsContext);
    const [query, setQuery] = useState('');
    const [loading, setLoading] = useState(false);
    const [searchArticle, setSearchArticle] = useState(null);

    function handleQueryChange(e) {
        setQuery(e.target.value);
    }

    function handleLoading(val) {
        console.log(val);
        setLoading(val);
    }

    function handleSearchSubmit(e) {
        e.preventDefault();
        //const [response, error, loading] = useFetch(`/api/waecoparts/language/${settings.language}/country/${settings.market}/articles/search/${query}`, { headers: { 'Content-Type': 'application/json' }});
        //setLoading(loading);
        //setHits(response);
        //setLoading(true);
        setSearchArticle(<SearchArticle key={query} query={query} onLoading={handleLoading} />);
        //GetData(`/language/${settings.language}/country/${settings.market}/articles/search/${query}`)
        //    .then(data => {
        //        console.log(data);
        //        setHits(data);
        //        setLoading(false);
        //    });
    }

    return (
        <div>
            <div className="row u-mbottom30">
                    <form onSubmit={handleSearchSubmit}>

                        <div className="col-md-12">
                            <div className="form-group">
                                <label className="u-textSemi16 u-block" htmlFor="plateNumber">{translation["TecAlliencePartSearch.PartsSearch.Browse.SearchByPartNumber"]} *</label>
                                <input type="text" autoFocus className="form-control input-lg" onChange={handleQueryChange} value={query} required />
                            </div>
                        </div>

                        <div className="col-xs-12">
                            <button disabled={loading} className="d-block btn btn-primary u-width100" type="submit">{translation["TecAlliencePartSearch.PartsSearch.Browse.Search"]}</button>
                        </div>
                    </form>
                {searchArticle && searchArticle}
            </div>
        </div>
    );
}
export default SearchTab;